module.exports = __webpack_public_path__ + "b5212766902618fa76e8056129ed2e86.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/backoffice/outlet-Icon.svg
// module id = 2875
// module chunks = 0